<template>

    <div class="main">

        <!-- 資料讀取中 -->
        <div id="mask" class="hide">
            <div class="text">
                <i class="fas fa-spinner fa-pulse"></i> 資料讀取中
            </div>
        </div>
        <!-- 標題 -->
        <div class="main-title">
            <b-row align-h="between">
                <b-col cols="auto"><h2 class="px-3">{{ title }}</h2></b-col>
                <b-col cols="auto" align-self="center"><b-breadcrumb :items="items"></b-breadcrumb></b-col>
            </b-row>
        </div>
        <div class="main-content">
            <!-- 表單及清單 -->
            <div id="plant_register" v-show="!form.isSubmitDone">

                <!-- 表單(使用者驗證) -->
                <div id="plant_form" class="w3-container w3-card-4 w3-light-grey w3-margin">
                    <p class="w3-center header-title">{{ form.title }}</p>
                    <!-- 版面參照:https://www.w3schools.com/w3css/tryit.asp?filename=tryw3css_examples_contact  -->
            
                    <!-- 驗證欄位 姓名 -->
                    <div class="w3-row w3-section">
                        <div class="field w3-col">
                            <i class="w3-xxlarge fa" :class="form.classUserName"></i>
                        </div>
                        <div class="value w3-rest">
                            <input class="w3-input w3-border" v-model="form.valueUserName" type="text" :placeholder="form.placeholderUserName" :disabled="!form.isVerifyDone">
                        </div>
                    </div>
            
                    <!-- 驗證欄位 電話 -->
                    <div class="w3-row w3-section">
                        <div class="field w3-col">
                            <i class="w3-xxlarge fa" :class="form.classUserPhone"></i>
                        </div>
                        <div class="value w3-rest">
                            <input class="w3-input w3-border" v-model="form.valueUserPhone" type="number" :placeholder="form.placeholderUserPhone" :disabled="!form.isVerifyDone">
                        </div>
                    </div>

                    <!-- 驗證按鈕 -->
                    <p v-show="!form.isVerifyDone">
                        <button class="w3-button w3-block w3-amber" @click="onVerify">
                            <i class="fa" :class="button.classVerify" aria-hidden="true"></i> {{ button.labelVerify }}
                        </button>
                    </p>
                </div>

                <!-- 新增、提交按鈕 -->
                <p v-show="form.isVerifyDone" class="plant_btns_insert_send">
                    <button class="w3-button w3-teal" @click="onInsert"><i class="fa" :class="button.classAddPlant" aria-hidden="true"></i> {{ button.labelAddPlant }}</button>&nbsp;
                    <button class="w3-button w3-brown" @click="onSubmit"><i class="fa" :class="button.classSubmitPlant" aria-hidden="true"></i> {{ button.labelSubmitPlant }}</button>
                </p>

                <!-- 目前共有 n 筆種植紀錄 -->
                <p class="plant_amount" v-show="form.isVerifyDone && plant.length > 0"> 目前共有 {{ plant.length }} 筆種植紀錄。</p>

                <!-- 清單(已驗證完後才呈現) -->
                <p id="plant_list" v-show="form.isVerifyDone && plant.length > 0">
                    
                    <template v-for="(value, key) in plant">
                        
                        <div class="item w3-khaki w3-hover-shadow w3-center" :key="'item'+key">
                            <div class="w3-row">
                                <div class="w3-col w3-container" style="width: 100%; margin-top: 10px;">
                                
                                    <!-- 第 N 筆紀錄 -->
                                    <p class="header-title">
                                        <span style="float:inline-start;">● 第 {{ key + 1 }} 筆種植紀錄</span>
                                        <i @click="onVisibility(key,!value.Visibility)" class="fa" :class="value.Visibility?'fa-chevron-circle-down':'fa-chevron-circle-up'" style="font-size: x-large;" aria-hidden="true"></i>
                                    </p>
                                    <!-- 縣市 -->
                                    <p class="info" v-show="value.Visibility && isDevelop">
                                        <span class="field">{{ modal.plant.labelCITY_ID }}</span>
                                        <span class="value">{{ value.CITY_NAME }}</span> <span class="value" v-show="value.Visibility && isDevelop">({{ value.CITY_ID }})</span>
                                    </p>
                                    <!-- 鄉鎮市區 -->
                                    <p class="info" v-show="value.Visibility">
                                        <span class="field">{{ modal.plant.labelTOWN_ID }}</span>
                                        <span class="value">{{ value.TOWN_NAME }}</span> <span class="value" v-show="value.Visibility && isDevelop">({{ value.TOWN_ID }})</span>
                                    </p>
                                    <!-- 地段(識別碼) -->
                                    <p class="info" v-show="value.Visibility && isDevelop">
                                        <span class="field">地段(識別碼) : </span>
                                        <span class="value">{{ value.SITESEC_ID }}</span>
                                    </p>
                                    <!-- 地段地號 -->
                                    <p class="info" v-show="value.Visibility">
                                        <span class="field">{{ modal.plant.labelSITESEC_NAME_NUMBER }}</span>
                                        <span class="value">{{ value.SITESEC_NAME }} - {{ value.SITESEC_NUMBER }}</span>
                                    </p>
                                    <!-- 年度 -->
                                    <p class="info" v-show="value.Visibility">
                                        <span class="field">{{ modal.plant.labelA_YEAR }}</span>
                                        <span class="value">{{ value.A_YEAR }}</span>
                                    </p>
                                    <!-- 期作 -->
                                    <p class="info" v-show="value.Visibility">
                                        <span class="field">{{ modal.plant.labelPERIOD }}</span>
                                        <span class="value">{{ value.PERIOD }}</span>
                                    </p>
                                    <!-- 作物種類 -->
                                    <p class="info" v-show="value.Visibility">
                                        <span class="field">{{ modal.plant.labelCROP_ID }}</span>
                                        <span class="value">{{ value.CROP_NAME }}</span>  <span class="value" v-show="value.Visibility && isDevelop">({{ value.CROP_ID }})</span>
                                    </p>
                                    <!-- 土地狀態 -->
                                    <p class="info" v-show="value.Visibility && false">
                                        <span class="field">{{ modal.plant.labelSTATE_P }}</span>
                                        <span class="value">{{ value.STATE_P }}</span>
                                    </p>
                                    <!-- 種植面積 -->
                                    <p class="info" v-show="value.Visibility">
                                        <span class="field">{{ modal.plant.labelAREA_P }}</span>
                                        <span class="value">{{ value.AREA_P }} 公頃</span>
                                    </p>
                                    <!-- 種植日期 -->
                                    <p class="info" v-show="value.Visibility">
                                        <span class="field">{{ modal.plant.labelDATE_P }}</span>
                                        <span class="value">{{ value.DATE_P }}</span>
                                    </p>
                                    <!-- 修改、刪除按鈕 -->
                                    <p style="text-align:right;" v-show="value.Visibility">
                                        <button class="w3-button w3-indigo" @click="onModify(value, key)"><i class="fa" :class="button.classEditPlant" aria-hidden="true"></i> {{ button.labelEditPlant }}</button>&nbsp;
                                        <button class="w3-button w3-red" @click="onDelete(key)"><i class="fa" :class="button.classDelPlant" aria-hidden="true"></i> {{ button.labelDelPlant }}</button>
                                    </p>

                                </div>
                            </div>
                        </div>

                    </template>
                </p>

                <!-- 種植資料為空的提示訊息 -->
                <div id="plant_empty_message" class="w3-panel w3-red w3-border w3-round" v-show="form.isVerifyDone && plant.length == 0">
                    <p class="header-title">
                        <i class="fa fa-exclamation-circle" aria-hidden="true"></i> {{ message.plantEmptyTitle }}
                    </p>
                    <p class="description">
                        {{ message.plantEmptyDescription }}
                    </p>
                </div>

            </div>
            <!-- 領取獎勵 -->
            <div id="receive_award" v-show="form.isSubmitDone">
                <!-- QrCode -->
                <div id="qr_code" class="w3-container">
                    <div class="w3-card-4 w3-dark-grey form-style">
                
                        <div class="w3-container w3-center">
                            <!-- 標題 -->
                            <p class="header-title">
                                {{ message.plantDoneSubmit }}
                            </p>
                            <!-- QrCode圖片 -->
                            <div id="qr_code_img" class="img-body" style="width: 150px;height: 150px;margin: auto;display: block;margin-top: 10px;margin-bottom: 10px;background: #FF0000;"></div>
                            
                            <p class="description" style="color:#FFFF00">
                                目前安卓系統手機無法下載圖片，需請使用者截圖(同時按住電源和調低音量按鈕)。
                            </p>
                            <p class="description">
                                {{ message.qrCodeUseReminder }}
                            </p>
                            <!-- 下載圖片、重新登記按鈕 -->
                            <div class="w3-section">
                                <button class="w3-button w3-green" @click="onDownloadQrCode"><i class="fa" :class="button.classDownloadQrCode" aria-hidden="true"></i> {{ button.labelDownloadQrCode }}</button>&nbsp;
                                <button class="w3-button w3-red" @click="onAgainRegister"><i class="fa" :class="button.classAgainRegister" aria-hidden="true"></i> {{ button.labelAgainRegister }}</button>
                            </div>
                        </div>
                
                    </div>
                </div>
            </div>
            <!-- 彈出視窗 -->
            <div id="dialog_register" class="w3-modal" :style="modal.plant.modalStyleProcess">
                <div class="body w3-modal-content w3-card-4 w3-animate-zoom">
        
                    <!-- 表頭 (操作動作、關閉視窗按鈕) -->
                    <header class="w3-container" :class="modal.plant.moduleProcessSubmit=='add'?'w3-teal':'w3-indigo'"> 
                        <span @click="modal.plant.modalStyleProcess.display='none'" class="w3-button w3-display-topright">&times;</span>
                        <h5><i class="fa" :class="modal.plant.iconProcessSubmit" aria-hidden="true"></i> {{ modal.plant.titleProcessSubmit }}</h5>
                    </header>
                    <!-- 縣市 -->
                    <div class="w3-row" v-show="isDevelop">
                        <div class="field w3-col w3-container">
                            <span class="required">*</span>{{ modal.plant.labelCITY_ID }}
                        </div>
                        <div class="value w3-col w3-container">
                            <select v-model="modal.plant.valueCITY_ID" :disabled="modal.plant.disabledCITY_ID" >
                                <option value="">
                                    {{ modal.plant.placeholderCITY_ID }}
                                </option>
                                <option v-for="(value, key) in menu.city" :value="value.Value" :key="'valueCITY_ID' + key">
                                    {{ value.Title }}
                                </option>
                            </select>
                        </div>
                    </div>
                    <!-- 鄉鎮市區 -->
                    <div class="w3-row">
                        <div class="field w3-col w3-container">
                            <span class="required">*</span>{{ modal.plant.labelTOWN_ID }}
                        </div>
                        <div class="value w3-col w3-container">
                            <select v-model="modal.plant.valueTOWN_ID" :disabled="modal.plant.disabledTOWN_ID" style="width: 150px">
                                <option value="">
                                    {{ modal.plant.placeholderTOWN_ID }}
                                </option>
                                <option v-for="(value, key) in menu.town" :value="value.Value" :key="'valueTOWN_ID' + key">
                                    {{ value.Title }}
                                </option>
                            </select>
                        </div>
                    </div>
                    <!-- 地段地號 -->
                    <div class="w3-row">
                        <div class="field w3-col w3-container">
                            <span class="required">*</span>地段地號 :
                        </div>
                        <div class="value w3-col w3-container">
                            <select v-model="modal.plant.valueSITESEC_NAME" :disabled="modal.plant.disabledSITESEC_NAME" style="width: 170px;">
                                <option value="">
                                    {{ modal.plant.placeholderSITESEC_NAME }}
                                </option>
                                <option v-for="(value, key) in modal.plant.menuSITESEC_NAME" :value="value.Value" :key="'valueSITESEC_NAME' + key">
                                    {{ value.Title }}
                                </option>
                            </select>&nbsp; 
                            <input type="number" style="width: 170px;" v-model="modal.plant.valueSITESEC_NUMBER" :disabled="modal.plant.disabledSITESEC_NUMBER" :placeholder="modal.plant.placeholderSITESEC_NUMBER" oninput="if(value.length>8)value=value.slice(0,8)">
                        </div>
                    </div>
                    <!-- 定位 -->
                    <div class="w3-row" v-show="false">
                        <div class="field w3-col w3-container">
                            {{ modal.plant.labelPOSITION }}
                        </div>
                        <div class="value w3-col w3-container">
                            <input type="text" style="max-width: 287px;width: 100%;" v-model="modal.plant.valuePOSITION" :disabled="modal.plant.disabledPOSITION" :placeholder="modal.plant.placeholderPOSITION">
                            <p style="margin-top: 10px;">
                                <button class="w3-button w3-teal" @click="onPosition"><i class="fa" :class="button.classPosition" aria-hidden="true"></i> {{ button.labelPosition }}</button>
                            </p>
                        </div>
                    </div>
                    <!-- 圖台 -->
                    <div class="w3-row">
                        <div class="w3-col w3-container" style="text-align: -webkit-right;">
                            <div id="map"></div>
                        </div>
                    </div> 
                    <!-- X座標 -->
                    <div class="w3-row" v-show="isDevelop">
                        <div class="field w3-col w3-container">
                            <span class="required">*</span>{{ modal.plant.labelTWD97X }}
                        </div>
                        <div class="value w3-col w3-container">
                            <input type="number" style="width: 180px;" v-model="modal.plant.valueTWD97X" :disabled="modal.plant.disabledTWD97X" :placeholder="modal.plant.placeholderTWD97X">
                        </div>
                    </div>
                    <!-- Y座標 -->
                    <div class="w3-row" v-show="isDevelop">
                        <div class="field w3-col w3-container">
                            <span class="required">*</span>{{ modal.plant.labelTWD97Y }}
                        </div>
                        <div class="value w3-col w3-container">
                            <input type="number" style="width: 180px;" v-model="modal.plant.valueTWD97Y" :disabled="modal.plant.disabledTWD97Y" :placeholder="modal.plant.placeholderTWD97Y">
                        </div>
                    </div>
                    <!-- 視野 -->
                    <div class="w3-row" v-show="isDevelop">
                        <div class="field w3-col w3-container">
                            <span class="required">*</span>{{ modal.plant.labelZOOM }}
                        </div>
                        <div class="value w3-col w3-container">
                            <input type="number" style="width: 180px;" v-model="modal.plant.valueZOOM" :disabled="modal.plant.disabledZOOM" :placeholder="modal.plant.placeholderZOOM">
                        </div>
                    </div>
                    <!-- 年度 -->
                    <div class="w3-row">
                        <div class="field w3-col w3-container">
                            <span class="required">*</span>{{ modal.plant.labelA_YEAR }}
                        </div>
                        <div class="value w3-col w3-container">
                            <select v-model="modal.plant.valueA_YEAR" :disabled="modal.plant.disabledA_YEAR" >
                                <option value="">
                                    {{ modal.plant.placeholderA_YEAR }}
                                </option>
                                <option v-for="(value, key) in menu.year" :value="value.Value" :key="'valueA_YEAR' + key">
                                    {{ value.Title }}
                                </option>
                            </select>
                        </div>
                    </div>
                    <!-- 期作 -->
                    <div class="w3-row">
                        <div class="field w3-col w3-container">
                            <span class="required">*</span>{{ modal.plant.labelPERIOD }}
                        </div>
                        <div class="value w3-col w3-container">
                            <select v-model="modal.plant.valuePERIOD" :disabled="modal.plant.disabledPERIOD" >
                                <option value="">
                                    {{ modal.plant.placeholderPERIOD }}
                                </option>
                                <option v-for="(value, key) in menu.period" :value="value.Value" :key="'valuePERIOD' + key">
                                    {{ value.Title }}
                                </option>
                            </select>
                        </div>
                    </div>
                    <!-- 作物種類 -->
                    <div class="w3-row">
                        <div class="field w3-col w3-container">
                            <span class="required">*</span>{{ modal.plant.labelCROP_ID }}
                        </div>
                        <div class="value w3-col w3-container" style="max-width: 170px;">
                            <v-select v-model="modal.plant.valueCROP_ID" :placeholder="modal.plant.placeholderCROP_ID" :options="menu.crop" :reduce="(option) => option.Value" label="Title"></v-select>
                        </div>
                    </div>
                    <!-- 土地狀態 -->
                    <div class="w3-row" v-show="false">
                        <div class="field w3-col w3-container">
                            <span class="required">*</span>{{ modal.plant.labelSTATE_P }}
                        </div>
                        <div class="value w3-col w3-container">
                            <select v-model="modal.plant.valueSTATE_P" :disabled="modal.plant.disabledSTATE_P" style="width:140px;">
                                <option value="">
                                    {{ modal.plant.placeholderSTATE_P }}
                                </option>
                                <option v-for="(value, key) in menu.state" :value="value.Value" :key="'valueSTATE_P' + key">
                                    {{ value.Title }}
                                </option>
                            </select>
                        </div>
                    </div>
                    <!-- 種植面積 -->
                    <div class="w3-row">
                        <div class="field w3-col w3-container">
                            <span class="required">*</span>{{ modal.plant.labelAREA_P }}
                        </div>
                        <div class="value w3-col w3-container">
                            <input type="number" style="width: 160px;" v-model="modal.plant.valueAREA_P" :disabled="modal.plant.disabledAREA_P" :placeholder="modal.plant.placeholderAREA_P"> 公頃
                        </div>
                    </div>
                    <!-- 種植日期 -->
                    <div class="w3-row" style=" margin-bottom: 20px;">
                        <div class="field w3-col w3-container">
                            <span class="required">*</span>{{ modal.plant.labelDATE_P }}
                        </div>
                        <div class="value w3-col w3-container">
                            <input type="date" style="width: 160px;" v-model="modal.plant.valueDATE_P" :disabled="modal.plant.disabledDATE_P" :placeholder="modal.plant.placeholderDATE_P">
                        </div>
                    </div>
                    <!-- 表尾 (操作動作、提交按鈕) -->
                    <p> 
                        <button class="w3-button w3-block" :class="modal.plant.moduleProcessSubmit=='add'?'w3-teal':'w3-indigo'"  @click="onSava"><i class="fa" :class="modal.plant.iconProcessSubmit" aria-hidden="true"></i> {{ modal.plant.btnProcessSubmit }}</button>
                    </p>
                    
                </div>
            </div>
        </div>

    </div>

</template>
<script>
import Map from 'ol/Map';
import View from 'ol/View';
import Feature from 'ol/Feature';
import { XYZ, 
         Vector as VectorSource, 
         //ImageStatic as Static 
        } from "ol/source";
import { fromLonLat, 
        //transformExtent 
        } from "ol/proj";
import { Tile,
         Vector as VectorLayer,
         //Image as ImageLayer, 
        } from "ol/layer";
//import KML from "ol/format/KML";
//import GeoJSON from "ol/format/GeoJSON";
import { 
        //Fill, 
        //Stroke, 
        Style, 
        Icon 
        } from "ol/style";
import { 
        Point
        } from "ol/geom";


    export default {
        data() {
            return {

                //api 取得作物清單
                apiGetCropList: (data) => this.userRequest.post("/API/Default/GetCropList", data),
                //api 取得地段清單
                apiGetSecList: (data) => this.userRequest.post("/API/Default/GetSecList", data),
                //api 取得地段資訊
                apiGetSecInfo: (data) => this.userRequest.post("/API/Default/GetSecInfo", data),
                //api 取得定位資訊
                apiGetPositionInfo: (data) => this.userRequest.post("/API/Default/GetPositionInfo", data),
                //api 種植紀錄提交
                apiPlantRegister: (data) => this.userRequest.post("/API/Default/PlantRegister", data),

                //標題
                title:"種植登記",

                //導覽列
                items: [
                    {
                        text: '首頁',
                        href: '#/'
                    },
                    {
                        text: '種植登記',
                        active: true
                    }
                ],

                //是否是在開發模式
                isDevelop:false,

                //QrCode 兌換頁面網址
                qr_code_url:"https://agri-plus.yunlin.gov.tw/#/ReceivedAward?qr_code=",  
                //qr_code_url:"http://localhost:8080/#/ReceivedAward?qr_code=",    

                //表單頁面
                form:{

                    title:"雲林縣主產作物農情調查登記系統",
                    
                    labelUserName: "姓名:",
                    //valueUserName: "林建安",
                    valueUserName: "",
                    classUserName: "fa-user",
                    placeholderUserName: "請輸入姓名",

                    labelUserPhone: "聯絡方式:",
                    //valueUserPhone: "0955818185",
                    valueUserPhone: "",
                    classUserPhone: "fa-phone",
                    placeholderUserPhone: "請輸入聯絡方式",

                    //是否驗證成功(因為甲方目前無法提供驗證API，暫時改成有輸入就給過)
                    //isVerifyDone:false,
                    isVerifyDone:true,

                    //是否提交成功
                    isSubmitDone:false,
                    //isSubmitDone:true,

                },
                //相關按鈕
                button:{

                    labelVerify:"驗證",
                    classVerify:"fa-user-circle",

                    labelPosition: "定位",
                    classPosition:"fa-bullseye",

                    labelAddPlant: "新增",
                    classAddPlant:"fa-plus",

                    labelEditPlant: "修改",
                    classEditPlant:"fa-paint-brush",

                    labelDelPlant: "刪除",
                    classDelPlant:"fa-trash",

                    labelSubmitPlant: "提交",
                    classSubmitPlant:"fa-envelope",

                    labelDownloadQrCode: "下載圖片",
                    classDownloadQrCode:"fa-download",

                    labelAgainRegister: "重新登記",
                    classAgainRegister:"fa-refresh",

                },
                //種植情況(清單)
                plant:[],   
                //彈出視窗
                modal:{

                    //種植情況
                    plant:{

                        // 用於 決定彈出視窗呈現或隱藏
                        modalStyleProcess: { display: "none" },
                        
                        // 用於 彈出視窗的動作(add-新增、edit-修改、browse-瀏覽)
                        moduleProcessSubmit: "add",
                        //moduleProcessSubmit: "edit",
                        //moduleProcessSubmit: "browse",
                        // 用於 彈出視窗的標題
                        titleProcessSubmit: "新增",
                        // 用於 彈出視窗的圖示(fa-plus 新增、fa-paint-brush 修改)
                        iconProcessSubmit: "",
                        // 用於 彈出視窗的按鈕名稱
                        btnProcessSubmit: "新增",
                        // 用於 彈出視窗要修改清單上的哪個項目(若是新增他會是-1，若是修改它會是清單上項目的索引值)
                        indexProcessSubmit: -1,

                        labelCITY_ID: "縣市 : ",
                        valueCITY_ID: "",
                        disabledCITY_ID: true,
                        placeholderCITY_ID: "請選擇縣市",

                        labelTOWN_ID: "鄉鎮市區 : ",
                        valueTOWN_ID: "",
                        disabledTOWN_ID: false,
                        placeholderTOWN_ID: "請選擇鄉鎮市區",
                        passWatchTOWN_ID: false,

                        labelPOSITION: "定位 : ",
                        valuePOSITION: "",
                        disabledPOSITION: false,
                        placeholderPOSITION: "請輸入地址後在點選定位",

                        labelSITESEC_NAME: "地段 : ",
                        valueSITESEC_NAME: "",
                        disabledSITESEC_NAME: false,
                        //placeholderSITESEC_NAME: "請輸入地段",
                        placeholderSITESEC_NAME: "點選地圖帶入地段",
                        menuSITESEC_NAME:[],

                        labelSITESEC_NUMBER: "地號 : ",
                        valueSITESEC_NUMBER: "",
                        disabledSITESEC_NUMBER: false,
                        //placeholderSITESEC_NUMBER: "請輸入地號",
                        placeholderSITESEC_NUMBER: "點選地圖帶入地號",

                        labelSITESEC_NAME_NUMBER: "地段地號 : ",

                        labelTWD97X: "X座標 : ",
                        valueTWD97X: "",
                        disabledTWD97X: true,
                        placeholderTWD97X: "請點選地圖取得X座標",

                        labelTWD97Y: "Y座標 : ",
                        valueTWD97Y: "",
                        disabledTWD97Y: true,
                        placeholderTWD97Y: "請點選地圖取得Y座標",

                        labelZOOM: "視野 : ",
                        valueZOOM: "",
                        disabledZOOM: true,
                        placeholderZOOM: "請點選地圖取得視野",
                        
                        labelA_YEAR: "年度 : ",
                        valueA_YEAR: "",
                        disabledA_YEAR: false,
                        placeholderA_YEAR: "請選擇年度",

                        labelSTATE_P: "土地狀態 : ",
                        valueSTATE_P: "",
                        disabledSTATE_P: false,
                        placeholderSTATE_P: "請選擇土地狀態",

                        labelPERIOD: "期作 : ",
                        valuePERIOD: "",
                        disabledPERIOD: false,
                        placeholderPERIOD: "請選擇期作",

                        labelCROP_ID: "作物種類 : ",
                        valueCROP_ID: "",
                        disabledCROP_ID: false,
                        placeholderCROP_ID: "請選擇作物種類",

                        labelAREA_P: "種植面積 : ",
                        valueAREA_P: "",
                        disabledAREA_P: false,
                        placeholderAREA_P: "請輸入種植面積",

                        labelDATE_P: "種植日期 : ",
                        valueDATE_P: "",
                        disabledDATE_P: false,
                        placeholderDATE_P: "請選擇種植日期",
                    },

                },
                //選單
                menu:{
                    //年度
                    year:[],
                    //期作
                    period:[],
                    //土地狀態
                    state:[],
                    //縣市
                    city:[],
                    //行政區
                    town:[],
                    //作物種類
                    crop:[]
                },
                //訊息
                message:{

                    //表單驗證成功
                    verifyDone:"驗證成功，請從下方輸入您的種植作物、日期、面積。",
                    //種植資料為空(標題)
                    plantEmptyTitle:"目前沒有任何種植紀錄",
                    //種植資料為空(敘述)
                    plantEmptyDescription:"請點選新增按鈕，輸入您的種植情形，並於圖台上點選您的種植位置，系統會自動帶入該位置的地段地號。",
                    //種植資料為空(警告)
                    plantEmptyAlert:"目前沒有任何種植紀錄，無法提交，至少需要一筆資料。",
                    //種植資料刪除確認
                    plantConfirmDelete:"您確定要刪除這筆資料?",
                    //種植資料提交確認
                    plantConfirmSubmit:"您確定要提交資料?",
                    //種植資料提交成功
                    plantDoneSubmit:"登記成功",

                    //QrCode使用提醒
                    qrCodeUseReminder:"請保留這張QrCode的圖片，持圖片前去相關農會，會有專人替您掃描QrCode，確認無誤後領取獎勵。",
                    //QrCode重新登記確認
                    qrCodeConfirmAgainRegister:"是否已將QrCode圖片下載留存，您確認要重新登記?",

                },
                //OpenLayers 相關物件
                //備註:因為地圖物件，會用到很多變數，所以統一，所有的地圖變數都宣告在 openLayers 物件內
                //備註:如果沒有特定的初始值，統一用null以方便外部去做判別
                openLayers:{

                    //地圖物件
                    Map:null,
                    //地圖預設值
                    Default:
                    {
                        //容器的ID
                        Target:'map',
                        //緯度
                        CenterLat:23.652574754046682,
                        //經度
                        CenterLng:120.36276133502504,
                        //TWD97X
                        TWD97X:184992.53879376827,
                        //TWD97Y
                        TWD97Y:2616692.675353226,
                        //視野(Zoom)
                        Zoom:11,
                    },
                    //地圖中心的相關物件
                    Center:{
                        //圖層
                        Layer:null,
                        //標記
                        Marker:null,
                        //位置
                        Point:null,
                    },
                    Layer:{

                        Tile:{
                            //正射影像圖(通用)
                            PHOTO2:null,
                            //臺灣通用電子地圖(無鐵公路)
                            EMAP9:null,
                            //村里界圖
                            Village:null
                        }     
                    }, 
                },
            }
        },
        watch: {

            //彈跳視窗-鄉鎮市區
            "modal.plant.valueTOWN_ID":function(val)
            {   
                if(val == "")
                {
                    window.vue.modal.plant.valueCITY_ID = "";
                    window.vue.modal.plant.valueCITY_NAME = "";
                    window.vue.modal.plant.menuSITESEC_NAME = [];
                    window.vue.modal.plant.valueSITESEC_NAME = "";
                }

                if(this.modal.plant.passWatchTOWN_ID)
                { 
                    this.modal.plant.passWatchTOWN_ID = false;
                    return false; 
                }

                if(val != "" && this.modal.plant.modalStyleProcess.display.toLowerCase() == "block")
                {
                    var item = this.getMenuInfo("town",val);
                    if(item != null)
                    {
                        //取得該鄉鎮市區地段清單
                        this.getSecList(val);
                        //定位該鄉鎮市區預設位置
                        this.goMap(item.TWD97X,item.TWD97Y,14);
                    }
                }
            },
            //彈出視窗的狀態
            "modal.plant.modalStyleProcess.display":function(val){

                if(val.toLowerCase() != "block")
                {
                    //關閉
                    this.onClearModalProcess();
                }
                else
                {
                    //打開
                }
            },

        },
        mounted(){

            window.vue = this;  //在created方法中，將變數全局化，主控台可用 window.vue._data 調閱或呼叫(若不用可以直接遮罩)
                                //例如:window.vue._data.map.getCesiumScene().setEnabled(false);

            //初始地圖                    
            this.initMap();
            //取得各選單 
            this.getMenuList(); 
        },
        created() {
               
        },
        destroyed() {

        },
        methods: {

            //啟用遮罩
            enableDefaultLoad:function()
            {
                this.enableMask();
                this.default_load = true;
            },
            //取消遮罩
            disableDefaultLoad:function()
            { 
                //暫時先設定延遲，否則watch會重複觸發
                const _this = this;
                window.ThreadTool.Delay(function(){
                
                    _this.disableMask();
                    _this.default_load = false;

                },this.delay_ms_api);
            },     
            // (TWD97X,TWD97Y) 轉換成 [X,Y]
            onTWD97ToXY: function(TWD97)
            {
                //回傳 [X,Y]
                TWD97[0] = parseFloat(TWD97[0]);
                TWD97[1] = parseFloat(TWD97[1]);
                return this.onLonLatToXY(window.proj4("EPSG:3826", "EPSG:4326", TWD97));
            },
            onTWD97ToXY2: function(TWD97X,TWD97Y)
            {
                //回傳 [X,Y]
                return this.onLonLatToXY(window.proj4("EPSG:3826", "EPSG:4326", [parseFloat(TWD97X), parseFloat(TWD97Y)]));
            },
            // (Lon經度,Lat緯度) 轉換成 [X,Y]
            onLonLatToXY: function(LonLat)
            {
                //回傳 [X,Y]
                LonLat[0] = parseFloat(LonLat[0]);
                LonLat[1] = parseFloat(LonLat[1]);
                return window.ol.proj.fromLonLat(LonLat);
            },
            // (X,Y) 轉換成 [TWD97X,TWD97Y]
            onXYToTWD97: function(XY)
            {
                //回傳 [TWD97X,TWD97Y]
                XY[0] = parseFloat(XY[0]);
                XY[1] = parseFloat(XY[1]);
                return this.onLonLatToTWD97(window.ol.proj.toLonLat(XY));
            },
            onXYToTWD972: function(X,Y)
            {
                //回傳 [TWD97X,TWD97Y]
                return this.onLonLatToTWD97(window.ol.proj.toLonLat([parseFloat(X),parseFloat(Y)]));
            },
            // (X,Y) 轉換成 [Lon經度,Lat緯度]
            onXYToLonLat: function(XY)
            {
                //回傳 [Lon經度,Lat緯度]
                XY[0] = parseFloat(XY[0]);
                XY[1] = parseFloat(XY[1]);
                return window.ol.proj.toLonLat(XY);
            },
            onXYToLonLat2: function(X,Y)
            {
                //回傳 [Lon經度,Lat緯度]
                return window.ol.proj.toLonLat([parseFloat(X),parseFloat(Y)]);
            },
            // (Lon經度,Lat緯度) 轉換成 [TWD97X,TWD97Y]
            onLonLatToTWD97: function(LonLat)
            {
                //回傳 [TWD97X,TWD97Y]
                LonLat[0] = parseFloat(LonLat[0]);
                LonLat[1] = parseFloat(LonLat[1]);
                return window.proj4("EPSG:4326", "EPSG:3826", LonLat);
            },
            // (TWD97X,TWD97Y) 轉換成 [Lon經度,Lat緯度]
            onTWD97ToLonLat2: function(TWD97X,TWD97Y)
            {
                //回傳 [Lon經度,Lat緯度]
                return window.proj4("EPSG:3826", "EPSG:4326", [parseFloat(TWD97X), parseFloat(TWD97Y)]);
            },
            // 是否為空的欄位
            isEmptyValue: function(value){

                var state = false;

                if(value == '')
                {
                    state = true;
                }

                return state;
            },
            // 初始(地圖)
            initMap: function () { 

                const _this = this;
                //正射影像圖(通用)
                this.openLayers.Layer.Tile.PHOTO2 = new Tile({
                    minZoom: 7,
                    maxZoom: 18,
                    source: new XYZ({
                        url: "http://wmts.nlsc.gov.tw/wmts/PHOTO2/default/EPSG:3857/{z}/{y}/{x}"
                    }),
                    zIndex: 1
                });
                //臺灣通用電子地圖(無鐵公路)
                this.openLayers.Layer.Tile.EMAP9 = new Tile({
                    minZoom: 7,
                    maxZoom: 18,
                    source: new XYZ({
                        url: "http://wmts.nlsc.gov.tw/wmts/EMAP/default/EPSG:3857/{z}/{y}/{x}"
                    }),
                    zIndex: 1
                });
                //村里界圖
                this.openLayers.Layer.Tile.Village = new Tile({
                    minZoom: 7,
                    maxZoom: 18,
                    source: new XYZ({
                        //縣市界
                        //url: "https://wmts.nlsc.gov.tw/wmts/CITY/default/EPSG:3857/{z}/{y}/{x}"
                        //鄉鎮區界
                        //url: "https://wmts.nlsc.gov.tw/wmts/TOWN/default/EPSG:3857/{z}/{y}/{x}"
                        //村里界圖
                        url: "https://wmts.nlsc.gov.tw/wmts/Village/default/EPSG:3857/{z}/{y}/{x}"
                        //地段外圍圖(後期可以考慮這個，這個直接把地段名稱、地段識別碼(範例:奮起段PD0424)秀出來)
                        //url: "https://wmts.nlsc.gov.tw/wmts/LANDSECT/default/EPSG:3857/{z}/{y}/{x}"
                        
                    }),
                    zIndex: 1
                });
                //圖台
                this.openLayers.Map = new Map({
                    target: _this.openLayers.Default.Target,
                    layers: [
                        //臺灣通用電子地圖(無鐵公路)
                        this.openLayers.Layer.Tile.EMAP9,
                        //村里界圖
                        this.openLayers.Layer.Tile.Village,
                    ],
                    view: new View({
                        minZoom: 7,
                        maxZoom: 18,
                        center: fromLonLat([_this.openLayers.Default.CenterLng, _this.openLayers.Default.CenterLat]),
                        zoom: _this.openLayers.Default.Zoom
                    })
                });
                //中心點
                this.openLayers.Center.Layer = new VectorLayer({
                    source: new VectorSource(),
                    style: new Style({
                        image: new Icon({
                            anchor: [0.5, 1],
                            src: 'static/img/red-point.svg'
                        })
                    }),
                    zIndex: 9   //備註 zIndex 越大會越上層
                });

                this.openLayers.Map.addLayer(this.openLayers.Center.Layer);
                this.openLayers.Center.Point = new Point(fromLonLat([_this.openLayers.Default.CenterLng, _this.openLayers.Default.CenterLat]));
                this.openLayers.Center.Marker = new Feature(this.openLayers.Center.Point);
                this.openLayers.Center.Layer.getSource().addFeature(this.openLayers.Center.Marker);

                /** 註冊監聽事件-當滑鼠單擊時 */
                this.openLayers.Map.on('click', function (e) {

                    var aTWD97  = window.vue.onXYToTWD97(e.coordinate);
                    var aLatLon = window.vue.onXYToLonLat(e.coordinate);
                    window.vue.openLayers.Map.getView().setCenter(e.coordinate);
                    window.vue.openLayers.Center.Point.setCoordinates(window.vue.openLayers.Map.getView().getCenter());
                    window.vue.modal.plant.valueZOOM = window.vue.openLayers.Map.getView().getZoom();
                    window.vue.modal.plant.valueTWD97X = aTWD97[0];
                    window.vue.modal.plant.valueTWD97Y = aTWD97[1];

                    //取得地段資訊
                    window.vue.getSecInfo(aLatLon[1],aLatLon[0]);

                    //暫時先用假的地段地號，方便測試，後期會串接API
                    //window.vue.modal.plant.valueSITESEC_NAME = "華興段三小段";
                    //window.vue.modal.plant.valueSITESEC_NUMBER = "1410000";

                });

                /** 註冊監聽事件-當滑鼠放開時 */
                this.openLayers.Map.on('moveend', function (e) {

                    console.log(e);
                    window.vue.valueProcessZOOM = window.vue.openLayers.Map.getView().getZoom();
                });
            },
            // 定位(地圖、中心點)
            goMap:function(aTWD97X,aTWD97Y,aZOOM){

                //解決地圖第一次開啟呈現會有空白的問題
                window.ThreadTool.Delay(function(){

                    window.vue.openLayers.Map.updateSize();
            
                },500);
                
                this.valueProcessZOOM = aZOOM;
                this.valueProcessTWD97X = aTWD97X;
                this.valueProcessTWD97Y = aTWD97Y;

                var aTWD97  = [aTWD97X,aTWD97Y];
                this.openLayers.Map.getView().animate({center: this.onTWD97ToXY(aTWD97)}, {zoom: aZOOM});
                this.openLayers.Center.Point.setCoordinates(this.onTWD97ToXY(aTWD97));
            },
            //取得選單資訊
            getMenuList:function(){

                //暫時先寫死，承辦有提出作物清單，有的作物是資料表沒有的
                //this.getCropList();
                this.menu.year = [];
                var year = new Date().getFullYear();
                year = year - 1911;
                for(var i=year ; i >= (year-10) ; i--)
                {
                    this.menu.year.push({Title:i,Value:i});
                }
        
                this.menu.state = [];
                this.menu.state.push({Title:"休耕",Value:"休耕"});
                this.menu.state.push({Title:"種植",Value:"種植"});

                this.menu.period = [];
                //this.menu.period.push({Title:"全年",Value:"全年"});
                this.menu.period.push({Title:"一期作",Value:"一期作"});
                this.menu.period.push({Title:"二期作",Value:"二期作"});
                this.menu.period.push({Title:"裡作",Value:"裡作"});
                
                this.menu.city = [];
                this.menu.city.push({ Title:"臺北市",Value:"A",TWD97X:"305813.7359",TWD97Y:"2775076.557" });
                this.menu.city.push({ Title:"臺中市",Value:"B",TWD97X:"239057.2923",TWD97Y:"2681426.347" });
                this.menu.city.push({ Title:"基隆市",Value:"C",TWD97X:"322800.2427",TWD97Y:"2779450.17" });
                this.menu.city.push({ Title:"臺南市",Value:"D",TWD97X:"180850.663",TWD97Y:"2561134.165" });
                this.menu.city.push({ Title:"高雄市",Value:"E",TWD97X:"210466.3598",TWD97Y:"2543557.857" });
                
                this.menu.city.push({ Title:"新北市",Value:"F",TWD97X:"310100.8982",TWD97Y:"2764473.773" });
                this.menu.city.push({ Title:"宜蘭縣",Value:"G",TWD97X:"315395.2486",TWD97Y:"2718713.011" });
                this.menu.city.push({ Title:"桃園市",Value:"H",TWD97X:"276040.3219",TWD97Y:"2755080.603" });
                this.menu.city.push({ Title:"嘉義市",Value:"I",TWD97X:"193608.0073",TWD97Y:"2597605.482" });
                this.menu.city.push({ Title:"新竹縣",Value:"J",TWD97X:"266562.2481",TWD97Y:"2730457.243" });
                
                this.menu.city.push({ Title:"苗栗縣",Value:"K",TWD97X:"242097.4382",TWD97Y:"2708617.559" });
                this.menu.city.push({ Title:"南投縣",Value:"M",TWD97X:"248160.6029",TWD97Y:"2637588.661" });
                this.menu.city.push({ Title:"彰化縣",Value:"N",TWD97X:"195936.6278",TWD97Y:"2651198.644" });
                this.menu.city.push({ Title:"新竹市",Value:"O",TWD97X:"244568.9822",TWD97Y:"2742186.662" });
                this.menu.city.push({ Title:"雲林縣",Value:"P",TWD97X:"186069.0123",TWD97Y:"2620448.506" });
                
                this.menu.city.push({ Title:"嘉義縣",Value:"Q",TWD97X:"200951.2995",TWD97Y:"2594063.406" });
                this.menu.city.push({ Title:"屏東縣",Value:"T",TWD97X:"216752.5214",TWD97Y:"2486992.331" });
                this.menu.city.push({ Title:"花蓮縣",Value:"U",TWD97X:"288574.4537",TWD97Y:"2627677.375" });
                this.menu.city.push({ Title:"臺東縣",Value:"V",TWD97X:"254235.4819",TWD97Y:"2529071.908" });
                this.menu.city.push({ Title:"金門縣",Value:"W",TWD97X:"-15897.23452",TWD97Y:"2708649.239" });
                
                this.menu.city.push({ Title:"澎湖縣",Value:"X",TWD97X:"104500.0409",TWD97Y:"2605130.994" });
                this.menu.city.push({ Title:"連江縣",Value:"Z",TWD97X:"154477.9608",TWD97Y:"2897224.94" });
                
                this.menu.town = [];
                this.menu.town.push({ Title:"斗六市",Value:"P01",TWD97X:"205140.8233",TWD97Y:"2622601.056" });
                this.menu.town.push({ Title:"斗南鎮",Value:"P02",TWD97X:"197228.2676",TWD97Y:"2618657.888" });
                this.menu.town.push({ Title:"虎尾鎮",Value:"P03",TWD97X:"191809.1634",TWD97Y:"2623766.814" });
                this.menu.town.push({ Title:"西螺鎮",Value:"P04",TWD97X:"194769.3145",TWD97Y:"2630711.087" });
                this.menu.town.push({ Title:"土庫鎮",Value:"P05",TWD97X:"185211.2932",TWD97Y:"2620969.331" });

                this.menu.town.push({ Title:"北港鎮",Value:"P06",TWD97X:"177945.2347",TWD97Y:"2610048.846" });
                this.menu.town.push({ Title:"古坑鄉",Value:"P07",TWD97X:"210381.8169",TWD97Y:"2613611.161" });
                this.menu.town.push({ Title:"大埤鄉",Value:"P08",TWD97X:"191395.0163",TWD97Y:"2615902.559" });
                this.menu.town.push({ Title:"莿桐鄉",Value:"P09",TWD97X:"201997.409",TWD97Y:"2629612.18" });
                this.menu.town.push({ Title:"林內鄉",Value:"P10",TWD97X:"210805.394",TWD97Y:"2628039.454" });

                this.menu.town.push({ Title:"二崙鄉",Value:"P11",TWD97X:"188495.403",TWD97Y:"2632190.291" });
                this.menu.town.push({ Title:"崙背鄉",Value:"P12",TWD97X:"182120.1156",TWD97Y:"2630661.979" });
                this.menu.town.push({ Title:"麥寮鄉",Value:"P13",TWD97X:"172346.0934",TWD97Y:"2632129.478" });
                this.menu.town.push({ Title:"東勢鄉",Value:"P14",TWD97X:"174167.6762",TWD97Y:"2621578.853" });
                this.menu.town.push({ Title:"褒忠鄉",Value:"P15",TWD97X:"179807.7938",TWD97Y:"2623765.879" });

                this.menu.town.push({ Title:"臺西鄉",Value:"P16",TWD97X:"168405.7749",TWD97Y:"2623882.853" });
                this.menu.town.push({ Title:"元長鄉",Value:"P17",TWD97X:"181436.479",TWD97Y:"2615595.41" });
                this.menu.town.push({ Title:"四湖鄉",Value:"P18",TWD97X:"167754.407",TWD97Y:"2616090.131" });
                this.menu.town.push({ Title:"口湖鄉",Value:"P19",TWD97X:"162339.0381",TWD97Y:"2605903.415" });
                this.menu.town.push({ Title:"水林鄉",Value:"P20",TWD97X:"171931.9025",TWD97Y:"2606694.05" });

                this.menu.crop = [];
                this.menu.crop.push({ Title:"休耕",Value:"-1" });
                this.menu.crop.push({ Title:"梗稻(水稻)",Value:"C02" });
                this.menu.crop.push({ Title:"秈稻(水稻)",Value:"C03" });
                this.menu.crop.push({ Title:"落花生",Value:"102" });
                this.menu.crop.push({ Title:"甘藷",Value:"201" });
                this.menu.crop.push({ Title:"食用玉米",Value:"002" });
                this.menu.crop.push({ Title:"硬質玉米",Value:"001" });
                this.menu.crop.push({ Title:"大豆",Value:"101" });
                this.menu.crop.push({ Title:"蜀黍(高粱)",Value:"005" });
                this.menu.crop.push({ Title:"馬鈴薯",Value:"203" });
                this.menu.crop.push({ Title:"小麥",Value:"003" });
                this.menu.crop.push({ Title:"蘿蔔",Value:"416" });
                this.menu.crop.push({ Title:"胡蘿蔔",Value:"417" });
                this.menu.crop.push({ Title:"甘藍",Value:"419" });
                this.menu.crop.push({ Title:"大蒜(蒜頭)",Value:"437" });
                this.menu.crop.push({ Title:"蔥",Value:"438" });
                this.menu.crop.push({ Title:"蔥頭",Value:"439" });
                this.menu.crop.push({ Title:"食用番茄",Value:"425" });
                this.menu.crop.push({ Title:"西瓜",Value:"410" });
                this.menu.crop.push({ Title:"木瓜",Value:"627" });
                this.menu.crop.push({ Title:"文旦柚",Value:"607" });
                this.menu.crop.push({ Title:"茂谷柑",Value:"615" });
                this.menu.crop.push({ Title:"番石榴",Value:"623" });
                this.menu.crop.push({ Title:"香蕉",Value:"601" });
                this.menu.crop.push({ Title:"咖啡",Value:"337" });
                this.menu.crop.push({ Title:"生食甘蔗",Value:"306" });
                this.menu.crop.push({ Title:"抱子甘藍",Value:"420" });
                this.menu.crop.push({ Title:"結球白菜",Value:"421" });
                this.menu.crop.push({ Title:"不結球白菜",Value:"422" });
                this.menu.crop.push({ Title:"青蒜",Value:"436" });
                this.menu.crop.push({ Title:"洋蔥",Value:"415" });
                this.menu.crop.push({ Title:"茶",Value:"305" });
                this.menu.crop.push({ Title:"青割玉米",Value:"D13" });
                this.menu.crop.push({ Title:"牧草",Value:"D17" });
                this.menu.crop.push({ Title:"原料甘蔗",Value:"D08" });
                this.menu.crop.push({ Title:"芋頭",Value:"440" });
                this.menu.crop.push({ Title:"薑",Value:"441" });
                this.menu.crop.push({ Title:"荸薺",Value:"442" });
                this.menu.crop.push({ Title:"蓮藕",Value:"443" });
                this.menu.crop.push({ Title:"結頭菜",Value:"444" });
                this.menu.crop.push({ Title:"蕗蕎",Value:"445" });
                this.menu.crop.push({ Title:"其他雜糧",Value:"99" });
                this.menu.crop.push({ Title:"花豆",Value:"103" });
                this.menu.crop.push({ Title:"米豆",Value:"106" });
                this.menu.crop.push({ Title:"蠶豆",Value:"107" });
                this.menu.crop.push({ Title:"紅豆",Value:"104" });
                this.menu.crop.push({ Title:"綠豆",Value:"105" });
                this.menu.crop.push({ Title:"胡麻(芝麻)",Value:"301" });
                this.menu.crop.push({ Title:"棉花",Value:"302" });
                this.menu.crop.push({ Title:"向日葵",Value:"303" });
                this.menu.crop.push({ Title:"油菜子",Value:"304" });
                this.menu.crop.push({ Title:"其他豆類",Value:"199" });
                this.menu.crop.push({ Title:"樹薯",Value:"202" });
                this.menu.crop.push({ Title:"四川榨菜",Value:"446" });
                this.menu.crop.push({ Title:"大心芥菜",Value:"447" });
                this.menu.crop.push({ Title:"慈菇",Value:"448" });
                this.menu.crop.push({ Title:"其他莖菜",Value:"455" });
                this.menu.crop.push({ Title:"大芥菜",Value:"456" });
                this.menu.crop.push({ Title:"蕹菜",Value:"457" });
                this.menu.crop.push({ Title:"芹菜",Value:"458" });
                this.menu.crop.push({ Title:"菠菜",Value:"459" });
                this.menu.crop.push({ Title:"萵苣",Value:"460" });
                this.menu.crop.push({ Title:"莧菜",Value:"461" });
                this.menu.crop.push({ Title:"茼蒿",Value:"462" });
                this.menu.crop.push({ Title:"香芹菜",Value:"463" });
                this.menu.crop.push({ Title:"芫荽",Value:"464" });
                this.menu.crop.push({ Title:"芥藍",Value:"465" });
                this.menu.crop.push({ Title:"茴香",Value:"466" });
                this.menu.crop.push({ Title:"吉康菜",Value:"467" });
                this.menu.crop.push({ Title:"其他葉菜",Value:"470" });
                this.menu.crop.push({ Title:"花椰菜",Value:"471" });
                this.menu.crop.push({ Title:"青花菜",Value:"472" });
                this.menu.crop.push({ Title:"胡瓜",Value:"473" });
                this.menu.crop.push({ Title:"越瓜",Value:"474" });
                this.menu.crop.push({ Title:"冬瓜",Value:"475" });
                this.menu.crop.push({ Title:"苦瓜",Value:"476" });
                this.menu.crop.push({ Title:"茄子",Value:"477" });
                this.menu.crop.push({ Title:"菜豆(豇豆)",Value:"478" });
                this.menu.crop.push({ Title:"契作毛豆",Value:"479" });
                this.menu.crop.push({ Title:"豌豆",Value:"480" });
                this.menu.crop.push({ Title:"甜椒",Value:"481" });
                this.menu.crop.push({ Title:"辣椒",Value:"482" });
                this.menu.crop.push({ Title:"南瓜",Value:"483" });
                this.menu.crop.push({ Title:"佛手瓜",Value:"484" });
                this.menu.crop.push({ Title:"節瓜(毛瓜)",Value:"485" });
                this.menu.crop.push({ Title:"皇帝豆",Value:"486" });
                this.menu.crop.push({ Title:"扁蒲",Value:"487" });
                this.menu.crop.push({ Title:"絲瓜",Value:"488" });
                this.menu.crop.push({ Title:"黃秋葵",Value:"489" });
                this.menu.crop.push({ Title:"鵲豆(肉豆)",Value:"490" });
                this.menu.crop.push({ Title:"關刀豆",Value:"491" });
                this.menu.crop.push({ Title:"菱角",Value:"492" });
                this.menu.crop.push({ Title:"四季豆",Value:"493" });
                this.menu.crop.push({ Title:"田菁",Value:"502" });
                this.menu.crop.push({ Title:"太陽麻",Value:"508" });
                this.menu.crop.push({ Title:"油菜",Value:"509" });
                this.menu.crop.push({ Title:"鐵虎豆",Value:"510" });
                this.menu.crop.push({ Title:"青皮豆",Value:"513" });
                this.menu.crop.push({ Title:"鳳梨",Value:"602" });
                this.menu.crop.push({ Title:"椪柑",Value:"603" });
                this.menu.crop.push({ Title:"柳橙",Value:"604" });
                this.menu.crop.push({ Title:"桶柑",Value:"605" });
                this.menu.crop.push({ Title:"白柚",Value:"609" });
                this.menu.crop.push({ Title:"檸檬",Value:"611" });
                this.menu.crop.push({ Title:"葡萄柚",Value:"612" });
                this.menu.crop.push({ Title:"金柑",Value:"613" });
                this.menu.crop.push({ Title:"四季桔",Value:"616" });
                this.menu.crop.push({ Title:"其他柑桔",Value:"618" });
                this.menu.crop.push({ Title:"龍眼",Value:"619" });
                this.menu.crop.push({ Title:"本地種芒果",Value:"620" });
                this.menu.crop.push({ Title:"改良種芒果",Value:"621" });
                this.menu.crop.push({ Title:"檳榔",Value:"622" });
                this.menu.crop.push({ Title:"粟",Value:"004" });
                this.menu.crop.push({ Title:"大麥",Value:"006" });
                this.menu.crop.push({ Title:"黍",Value:"007" });
                this.menu.crop.push({ Title:"蕎麥",Value:"008" });
                this.menu.crop.push({ Title:"薏苡",Value:"009" });
                this.menu.crop.push({ Title:"採種用蔬菜",Value:"400" });
                this.menu.crop.push({ Title:"蘆筍",Value:"401" });
                this.menu.crop.push({ Title:"韭菜",Value:"402" });
                this.menu.crop.push({ Title:"竹筍",Value:"403" });
                this.menu.crop.push({ Title:"金針菜",Value:"404" });
                this.menu.crop.push({ Title:"山蕨",Value:"405" });
                this.menu.crop.push({ Title:"龍鬚菜",Value:"406" });
                this.menu.crop.push({ Title:"山蘇",Value:"407" });
                this.menu.crop.push({ Title:"洋香瓜",Value:"411" });
                this.menu.crop.push({ Title:"香瓜",Value:"412" });
                this.menu.crop.push({ Title:"瓜子瓜",Value:"413" });
                this.menu.crop.push({ Title:"草莓",Value:"414" });
                this.menu.crop.push({ Title:"茭白筍",Value:"418" });
                this.menu.crop.push({ Title:"加工番茄",Value:"426" });
                this.menu.crop.push({ Title:"豆薯",Value:"430" });
                this.menu.crop.push({ Title:"牛蒡",Value:"431" });
                this.menu.crop.push({ Title:"其他根菜",Value:"435" });
                this.menu.crop.push({ Title:"其他特作",Value:"D10" });
                this.menu.crop.push({ Title:"其他蔬菜",Value:"D12" });
                this.menu.crop.push({ Title:"瓊麻",Value:"307" });
                this.menu.crop.push({ Title:"香水茅",Value:"308" });
                this.menu.crop.push({ Title:"洛神葵",Value:"309" });
                this.menu.crop.push({ Title:"貴黍",Value:"310" });
                this.menu.crop.push({ Title:"仙草",Value:"311" });
                this.menu.crop.push({ Title:"紫蘇",Value:"312" });
                this.menu.crop.push({ Title:"圓藺草",Value:"313" });
                this.menu.crop.push({ Title:"其他短期特作",Value:"320" });
                this.menu.crop.push({ Title:"大甲藺",Value:"321" });
                this.menu.crop.push({ Title:"三角藺",Value:"322" });
                this.menu.crop.push({ Title:"茉莉",Value:"323" });
                this.menu.crop.push({ Title:"秀英",Value:"324" });
                this.menu.crop.push({ Title:"杭菊",Value:"325" });
                this.menu.crop.push({ Title:"油茶",Value:"326" });
                this.menu.crop.push({ Title:"亞麻",Value:"327" });
                this.menu.crop.push({ Title:"苧麻",Value:"328" });
                this.menu.crop.push({ Title:"荖藤",Value:"329" });
                this.menu.crop.push({ Title:"荖花",Value:"330" });
                this.menu.crop.push({ Title:"荖葉",Value:"331" });
                this.menu.crop.push({ Title:"甜菊",Value:"332" });
                this.menu.crop.push({ Title:"羅勒",Value:"333" });
                this.menu.crop.push({ Title:"山葵",Value:"334" });
                this.menu.crop.push({ Title:"黃梔",Value:"335" });
                this.menu.crop.push({ Title:"葛藤",Value:"336" });
                this.menu.crop.push({ Title:"通草",Value:"338" });
                this.menu.crop.push({ Title:"愛玉子",Value:"339" });
                this.menu.crop.push({ Title:"南薑",Value:"340" });
                this.menu.crop.push({ Title:"其他長期特作",Value:"399" });
                this.menu.crop.push({ Title:"其他果菜",Value:"499" });
                this.menu.crop.push({ Title:"李",Value:"624" });
                this.menu.crop.push({ Title:"桃",Value:"625" });
                this.menu.crop.push({ Title:"柿",Value:"626" });
                this.menu.crop.push({ Title:"蓮霧",Value:"628" });
                this.menu.crop.push({ Title:"巨峰葡萄",Value:"629" });
                this.menu.crop.push({ Title:"其他葡萄",Value:"633" });
                this.menu.crop.push({ Title:"枇杷",Value:"634" });
                this.menu.crop.push({ Title:"梅",Value:"635" });
                this.menu.crop.push({ Title:"荔枝",Value:"636" });
                this.menu.crop.push({ Title:"楊桃",Value:"638" });
                this.menu.crop.push({ Title:"梨",Value:"639" });
                this.menu.crop.push({ Title:"棗",Value:"641" });
                this.menu.crop.push({ Title:"百香果",Value:"643" });
                this.menu.crop.push({ Title:"人心果",Value:"645" });
                this.menu.crop.push({ Title:"可可椰子",Value:"646" });
                this.menu.crop.push({ Title:"可可",Value:"647" });
                this.menu.crop.push({ Title:"酪梨",Value:"648" });
                this.menu.crop.push({ Title:"紅龍果",Value:"651" });
                this.menu.crop.push({ Title:"番荔枝(大目種)",Value:"652" });
                this.menu.crop.push({ Title:"番荔枝(鳳梨釋迦)",Value:"653" });
                this.menu.crop.push({ Title:"其他果樹",Value:"698" });
                this.menu.crop.push({ Title:"桑",Value:"699" });
                this.menu.crop.push({ Title:"山藥",Value:"802" });
                this.menu.crop.push({ Title:"薄荷",Value:"804" });
                this.menu.crop.push({ Title:"其他藥用",Value:"811" });
                this.menu.crop.push({ Title:"洋菇",Value:"951" });
                this.menu.crop.push({ Title:"段木香菇",Value:"952" });
                this.menu.crop.push({ Title:"太空包香菇",Value:"953" });
                this.menu.crop.push({ Title:"木耳",Value:"955" });


            },
            // 取得選單資訊(藉由Value)
            getMenuInfo:function(name,val)
            {
                var menu = null;
                var item = null;
                switch (name) {
                    case 'year': 
                        //年度
                        menu = this.menu.year;
                    break;
                    case 'period': 
                        //期作
                        menu = this.menu.period;
                    break;
                    case 'state':
                        //土地狀態 
                        menu = this.menu.state;
                    break;
                    case 'city': 
                        //縣市
                        menu = this.menu.city;
                    break;
                    case 'town':
                        //行政區 
                        menu = this.menu.town;
                    break;
                    case 'crop': 
                        //作物種類
                        menu = this.menu.crop;
                    break;
                    case 'modal.plant.menuSITESEC_NAME': 
                        //地段
                        menu = this.modal.plant.menuSITESEC_NAME;
                    break;
                }

                if(menu == null)
                {
                    return null;
                }
                else
                {
                    for(var i=0 ; i < menu.length ; i++)
                    {
                        if(menu[i].Value == val)
                        {
                            item = menu[i];
                        } 
                    }

                    return item;
                }
            },
            //取得地段清單
            getSecList:function(TOWN_ID)
            {
                this.enableDefaultLoad();        
                this.apiGetSecList({

                    TOWN_ID:TOWN_ID,
                })
                .then((res)=>{

                    const json = JSON.parse(res.data);
                    const data = json;
                    if(data.State)
                    {
                        window.vue.modal.plant.valueCITY_ID = "P";
                        window.vue.modal.plant.valueCITY_NAME = "雲林縣";

                        window.vue.modal.plant.menuSITESEC_NAME = [];
                        window.vue.modal.plant.valueSITESEC_NAME = "";

                        for(var i=0 ; i<data.SITESEC_MENU.length ; i++)
                        {
                            window.vue.modal.plant.menuSITESEC_NAME.push({

                                Title:data.SITESEC_MENU[i].SITESEC_NAME,
                                Value:data.SITESEC_MENU[i].SITESEC_NAME,
                                SITESEC_ID:data.SITESEC_MENU[i].SITESEC_ID,
                                SITESEC_NAME:data.SITESEC_MENU[i].SITESEC_NAME
                            });
                        }

                    }
                    else
                    {
                        alert(data.Message);
                    }
                    window.vue.disableDefaultLoad();
                })
                .catch((err)=> {
                    console.log(err);
                    window.vue.disableDefaultLoad();
                }); 
            },  
            //取得地段資訊
            getSecInfo:function(Lat,Lon)
            {
                this.enableDefaultLoad();        
                this.apiGetSecInfo({

                    Lat:Lat,
                    Lon:Lon
                })
                .then((res)=>{

                    const json = JSON.parse(res.data);
                    const data = json.Result;
                    console.log(data);
                    if(data.State)
                    {
                        //取得地段資訊成功
                        if(data.CITY_ID == "P")
                        {
                            //只抓雲林縣的資料，其他縣市不納入
                            window.vue.modal.plant.valueCITY_ID = data.CITY_ID;
                            window.vue.modal.plant.valueCITY_NAME = data.CITY_NAME;

                            //window.vue.modal.plant.valueTOWN_ID = "";
                            //window.vue.modal.plant.passWatchTOWN_ID = true;
                            //window.vue.modal.plant.valueTOWN_ID = data.TOWN_ID;
                            //watch觸發會有問題，暫時先改成下面這種方式。
                            if(window.vue.modal.plant.valueTOWN_ID != data.TOWN_ID)
                            {
                                window.vue.modal.plant.passWatchTOWN_ID = true;
                                window.vue.modal.plant.valueTOWN_ID = data.TOWN_ID;
                            }

                            window.vue.modal.plant.valueTOWN_NAME = data.TOWN_NAME;

                            window.vue.modal.plant.menuSITESEC_NAME = [];
                            window.vue.modal.plant.valueSITESEC_NAME = "";
                            window.vue.modal.plant.valueSITESEC_NUMBER = "";

                            for(var i=0 ; i<data.SITESEC_MENU.length ; i++)
                            {
                                window.vue.modal.plant.menuSITESEC_NAME.push({

                                    Title:data.SITESEC_MENU[i].SITESEC_NAME,
                                    Value:data.SITESEC_MENU[i].SITESEC_NAME,
                                    SITESEC_ID:data.SITESEC_MENU[i].SITESEC_ID,
                                    SITESEC_NAME:data.SITESEC_MENU[i].SITESEC_NAME
                                });
                            }
                            window.vue.modal.plant.valueSITESEC_NAME = data.SITESEC_NAME;
                            window.vue.modal.plant.valueSITESEC_NUMBER = data.SITESEC_NUMBER;
                        }
                        else
                        {
                            window.vue.modal.plant.valueCITY_ID = "";
                            window.vue.modal.plant.valueCITY_NAME = "";

                            window.vue.modal.plant.valueTOWN_ID = "";
                            window.vue.modal.plant.valueTOWN_NAME = "";

                            window.vue.modal.plant.menuSITESEC_NAME = [];
                            window.vue.modal.plant.valueSITESEC_NAME = "";
                            window.vue.modal.plant.valueSITESEC_NUMBER = "";

                            alert("您點選的地方非雲林縣市，請重新點選。");
                        }

                    }
                    else
                    {
                        window.vue.modal.plant.valueCITY_ID = "";
                        window.vue.modal.plant.valueCITY_NAME = "";

                        window.vue.modal.plant.valueTOWN_ID = "";
                        window.vue.modal.plant.valueTOWN_NAME = "";

                        window.vue.modal.plant.menuSITESEC_NAME = [];
                        window.vue.modal.plant.valueSITESEC_NAME = "";
                        window.vue.modal.plant.valueSITESEC_NUMBER = "";

                        alert("您點選的地方無法解析地段地號，請重新點選。");
                    }
                    window.vue.disableDefaultLoad();
                })
                .catch((err)=> {
                    console.log(err);
                    window.vue.disableDefaultLoad();
                }); 
            }, 
            //取得定位資訊
            getPositionInfo:function()
            {
                this.enableDefaultLoad();        
                this.apiGetPositionInfo({

                    Address:this.modal.plant.valuePOSITION,
                })
                .then((res)=>{

                    const json = JSON.parse(res.data);
                    const data = json.Result;
                    console.log(data);
                    if(data.State)
                    {
                        alert("定位成功，記得點選地圖，標註您的種植位置。");
                        var TWD97 = window.vue.onLonLatToTWD97([data.Lon,data.Lat]);
                        window.vue.goMap(TWD97[0],TWD97[1],15);
                        window.vue.modal.plant.valuePOSITION = "";
                    }
                    else
                    {
                        alert("定位失敗，原因【地址解析失敗】，請重新輸入地址試試。");
                    }
                    window.vue.disableDefaultLoad();
                })
                .catch((err)=> {
                    console.log(err);
                    window.vue.disableDefaultLoad();
                }); 
            }, 
            //取得作物清單
            getCropList:function(){
                this.enableDefaultLoad(); 
                this.apiGetCropList({

                })
                .then((res)=>{

                    const data = JSON.parse(res.data);
                    console.log(data);
                    this.menu.crop = [];

                    if(data.length > 0)
                    {
                        this.menu.crop.push({ 
                            Title:"休耕",
                            Value:"-1"
                        });

                        for(var i=0 ; i<data.length ; i++)
                        {
                            this.menu.crop.push({ 
                                Title:data[i].C_NAME,
                                Value:data[i].C_ID
                            });
                        }
                    }

                    window.vue.disableDefaultLoad();
                })
                .catch((err)=> {
                    console.log(err);
                    window.vue.disableDefaultLoad();
                }); 
            },
            // 取得使用者Xxx欄位未輸入訊息
            getPleaseEnterField: function(ParamName) { return "請輸入【" + ParamName + "】！"; },
            // 取得使用者Xxx欄位未選擇訊息
            getPleaseChooseField: function(ParamName) { return "請選擇【" + ParamName + "】！"; },
            // 取得使用者Xxx欄位為空訊息
            getErrorMessageParamEmpty: function(ParamName) { return "操作失敗，【" + ParamName + "】不可為空！"; },
            // 取得地號(修正，長度不足左邊補0)
            getSitesecNumber(sitesec_number){

                var sitesec_number_new = sitesec_number + "";
                if(sitesec_number_new.length < 8)
                {
                    sitesec_number_new = sitesec_number_new.padStart(8,'0');            
                }
                return sitesec_number_new;
            },
            // 設定QrCode
            setQrCode:function(qr_code){
            
                var url = this.qr_code_url + qr_code;

                document.getElementById("qr_code_img").innerHTML = "";
                new window.QRCode(document.getElementById("qr_code_img"), {
                    text : url,
                    width : 150,
                    height : 150
                });
            },
            // 表單驗證
            onVerify:function(){

                if(this.isEmptyValue(this.form.valueUserName)){  alert(this.getErrorMessageParamEmpty("姓名")); return false; }
                if(this.isEmptyValue(this.form.valueUserPhone)){  alert(this.getErrorMessageParamEmpty("電話")); return false; }
                if(this.form.valueUserPhone.length != 10){alert("請輸入10碼的手機號碼，範例【0987654321】。"); return false;}

                alert(this.message.verifyDone);
                this.form.isVerifyDone = true;
            },
            // 設定彈出視窗的作業模式
            onSetModalProcessModule: function(module){

                if(module == "add"){
        
                    this.modal.plant.titleProcessSubmit = "新增";
                    this.modal.plant.btnProcessSubmit = "新增";
                    this.modal.plant.iconProcessSubmit = "fa-plus";
                    this.modal.plant.moduleProcessSubmit = module;
                    
                }else if(module == "edit"){
        
                    this.modal.plant.titleProcessSubmit = "修改";
                    this.modal.plant.btnProcessSubmit = "修改";
                    this.modal.plant.iconProcessSubmit = "fa-paint-brush";
                    this.modal.plant.moduleProcessSubmit = module; 
                }
            },
            // 新增
            onInsert:function(){

                this.onClearModalProcess();
                this.onSetModalProcessModule("add");
                this.modal.plant.indexProcessSubmit = -1;
                this.modal.plant.modalStyleProcess.display = "block";

                this.goMap(this.openLayers.Default.TWD97X,this.openLayers.Default.TWD97Y,this.openLayers.Default.Zoom);
            },
            // 修改
            onModify:function(value,key){

                this.onClearModalProcess();
                this.onSetModalProcessModule("edit");
                this.modal.plant.indexProcessSubmit = key;
                this.modal.plant.modalStyleProcess.display = "block";

                //種植情況-縣市
                this.modal.plant.valueCITY_ID = value.CITY_ID;
                //種植情況-鄉鎮市區
                this.modal.plant.valueTOWN_ID = "";
                this.modal.plant.passWatchTOWN_ID = true;
                this.modal.plant.valueTOWN_ID = value.TOWN_ID;
                //種植情況-地段
                this.modal.plant.valueSITESEC_NAME = value.SITESEC_NAME;
                //種植情況-地段(選單)
                this.modal.plant.menuSITESEC_NAME = value.SITESEC_MENU;
                //種植情況-地號
                this.modal.plant.valueSITESEC_NUMBER = this.getSitesecNumber(value.SITESEC_NUMBER);
                //X座標
                this.modal.plant.valueTWD97X = value.TWD97X;
                //Y座標
                this.modal.plant.valueTWD97Y = value.TWD97Y;
                //視野
                this.modal.plant.valueZOOM = value.ZOOM;
                //種植情況-作物種類
                this.modal.plant.valueCROP_ID = value.CROP_ID;
                //種植情況-年度
                this.modal.plant.valueA_YEAR = value.A_YEAR;
                //種植情況-期作
                this.modal.plant.valuePERIOD = value.PERIOD;
                //種植情況-土地狀態
                this.modal.plant.valueSTATE_P = value.STATE_P;
                //種植情況-種植面積
                this.modal.plant.valueAREA_P = value.AREA_P;
                //種植情況-種植日期
                this.modal.plant.valueDATE_P = value.DATE_P;

                this.goMap(value.TWD97X,value.TWD97Y,value.ZOOM);
            },
            // 儲存(新增、修改、瀏覽 點選視窗下面的按鈕)
            onSava: function () {

                //新增或修改 都要驗證欄位
                if(this.modal.plant.moduleProcessSubmit == "add" || this.modal.plant.moduleProcessSubmit == "edit")
                {
                    //if(this.modal.plant.valueCITY_ID == ""){  alert(this.getPleaseChooseField("縣市"));  return false; }
                    //if(this.modal.plant.valueTOWN_ID == ""){  alert(this.getPleaseChooseField("鄉鎮市區"));  return false; }
                    if(this.modal.plant.valueSITESEC_NAME == ""){  alert(this.getPleaseChooseField("地段"));  return false; }
                    if(this.modal.plant.valueSITESEC_NUMBER == ""){  alert(this.getPleaseEnterField("地號"));  return false; }   

                    //使用者可能完全沒有點地圖
                    var aTWD97  = window.vue.onXYToTWD97(window.vue.openLayers.Center.Point.getCoordinates());
                    if(this.modal.plant.valueTWD97X == ""){  this.modal.plant.valueTWD97X = aTWD97[0]; }  
                    if(this.modal.plant.valueTWD97Y == ""){  this.modal.plant.valueTWD97Y = aTWD97[1]; }  
                    if(this.modal.plant.valueZOOM == ""){   this.modal.plant.valueZOOM = window.vue.openLayers.Map.getView().getZoom(); }

                    if(this.modal.plant.valueTWD97X == ""){  alert(this.getPleaseEnterField("X座標"));  return false; }  
                    if(this.modal.plant.valueTWD97Y == ""){  alert(this.getPleaseEnterField("Y座標"));  return false; }  
                    if(this.modal.plant.valueZOOM == ""){  alert(this.getPleaseEnterField("視野"));  return false; }  
                    
                    
                    if(this.modal.plant.valueA_YEAR == ""){  alert(this.getPleaseChooseField("年度"));  return false; }  
                    if(this.modal.plant.valuePERIOD == ""){  alert(this.getPleaseChooseField("期作"));  return false; } 
                    //if(this.modal.plant.valueSTATE_P == ""){  alert(this.getPleaseChooseField("土地狀態"));  return false; }  
                                         
                    if(this.modal.plant.valueCROP_ID == ""){  alert(this.getPleaseChooseField("作物種類"));  return false; }  
                    if(this.modal.plant.valueAREA_P == ""){  alert(this.getPleaseEnterField("種植面積"));  return false; }  
                    if(Number(this.modal.plant.valueAREA_P) <= 0){  alert("種植面積必須大於0");  return false; } 

                    if(this.modal.plant.valueDATE_P == ""){  alert(this.getPleaseChooseField("種植日期"));  return false; }    
                }

                var LatLon = this.onTWD97ToLonLat2(Number(this.modal.plant.valueTWD97X),Number(this.modal.plant.valueTWD97Y));
                var itemCITY_ID = this.getMenuInfo("city",this.modal.plant.valueCITY_ID);
                var itemTOWN_ID = this.getMenuInfo("town",this.modal.plant.valueTOWN_ID);
                var itemCROP_ID = this.getMenuInfo("crop",this.modal.plant.valueCROP_ID);
                var itemSITESEC_ID = this.getMenuInfo("modal.plant.menuSITESEC_NAME",this.modal.plant.valueSITESEC_NAME);

                if(this.modal.plant.moduleProcessSubmit == "add")
                {            
                    this.plant.push({

                        CITY_ID:this.modal.plant.valueCITY_ID,
                        CITY_NAME:itemCITY_ID.Title,
                        TOWN_ID:this.modal.plant.valueTOWN_ID,
                        TOWN_NAME:itemTOWN_ID.Title,
                        SITESEC_ID:itemSITESEC_ID.SITESEC_ID,
                        SITESEC_NAME:this.modal.plant.valueSITESEC_NAME,
                        SITESEC_MENU:this.modal.plant.menuSITESEC_NAME,
                        SITESEC_NUMBER:this.getSitesecNumber(this.modal.plant.valueSITESEC_NUMBER),
                        TWD97X:Number(this.modal.plant.valueTWD97X),
                        TWD97Y:Number(this.modal.plant.valueTWD97Y),
                        ZOOM:Number(this.modal.plant.valueZOOM),
                        LAT:LatLon[1],
                        LON:LatLon[0],              
                        CROP_ID:this.modal.plant.valueCROP_ID,
                        CROP_NAME:itemCROP_ID.Title,
                        A_YEAR:this.modal.plant.valueA_YEAR,
                        PERIOD:this.modal.plant.valuePERIOD,
                        STATE_P:this.modal.plant.valueSTATE_P,
                        AREA_P:Number(this.modal.plant.valueAREA_P),
                        DATE_P:this.modal.plant.valueDATE_P,
                        Visibility:true, 
                    });
                    this.modal.plant.modalStyleProcess.display = 'none';
                }
                else if(this.modal.plant.moduleProcessSubmit == "edit")
                {
                    var key = this.modal.plant.indexProcessSubmit;
                    this.plant[key] = {

                        CITY_ID:this.modal.plant.valueCITY_ID,
                        CITY_NAME:itemCITY_ID.Title,
                        TOWN_ID:this.modal.plant.valueTOWN_ID,
                        TOWN_NAME:itemTOWN_ID.Title,
                        SITESEC_ID:itemSITESEC_ID.SITESEC_ID,
                        SITESEC_NAME:this.modal.plant.valueSITESEC_NAME,
                        SITESEC_MENU:this.modal.plant.menuSITESEC_NAME,
                        SITESEC_NUMBER:this.getSitesecNumber(this.modal.plant.valueSITESEC_NUMBER),
                        TWD97X:Number(this.modal.plant.valueTWD97X),
                        TWD97Y:Number(this.modal.plant.valueTWD97Y),
                        ZOOM:Number(this.modal.plant.valueZOOM),
                        LAT:LatLon[1],
                        LON:LatLon[0],
                        CROP_ID:this.modal.plant.valueCROP_ID,
                        CROP_NAME:itemCROP_ID.Title,
                        A_YEAR:this.modal.plant.valueA_YEAR,
                        PERIOD:this.modal.plant.valuePERIOD,
                        STATE_P:this.modal.plant.valueSTATE_P,
                        AREA_P:Number(this.modal.plant.valueAREA_P),
                        DATE_P:this.modal.plant.valueDATE_P,
                        Visibility:true,
                    };
                    this.modal.plant.modalStyleProcess.display = 'none';
                }

            },
            // 刪除
            onDelete: function (key) {

                var yes = confirm(this.message.plantConfirmDelete);

                if (yes) 
                {
                    //你按了確定按鈕
                    this.plant.splice(key, 1);
                } else {
                    //你按了取消按鈕 
                }
            },
            // 提交
            onSubmit: function(){

                if(this.form.valueUserName == ""){  alert(this.getPleaseEnterField("姓名"));  return false; }
                if(this.form.valueUserPhone == ""){  alert(this.getPleaseEnterField("聯絡方式"));  return false; }
                if(this.form.valueUserPhone.length != 10){ alert("請輸入10碼的手機號碼，範例【0987654321】。"); return false; }
                if(this.plant.length == 0){ alert(this.message.plantEmptyAlert); return false; }
                var yes = confirm(this.message.plantConfirmSubmit);
                if (yes) 
                {
                    //你按了確定按鈕
                    this.plantRegister();
                } 
                else 
                {
                    //你按了取消按鈕 
                }
            },
            // 呈現、隱藏項目
            onVisibility: function (key,visibility) 
            {
                this.plant[key].Visibility = visibility;
            },
            // 清空彈出視窗的所有欄位
            onClearModalProcess:function(){

                var mNowDate = new Date();

                //種植情況-縣市
                this.modal.plant.valueCITY_ID = "";
                //種植情況-鄉鎮市區
                this.modal.plant.valueTOWN_ID = "";
                //種植情況-地段
                this.modal.plant.valueSITESEC_NAME = "";
                //種植情況-地段(選單)
                this.modal.plant.menuSITESEC_NAME = [];
                //種植情況-地號
                this.modal.plant.valueSITESEC_NUMBER = "";
                //定位
                this.modal.plant.valuePOSITION = "";
                //X座標
                this.modal.plant.valueTWD97X = "";
                //Y座標
                this.modal.plant.valueTWD97Y = "";
                //視野
                this.modal.plant.valueZOOM = "";
                //種植情況-作物種類
                this.modal.plant.valueCROP_ID = "";
                //種植情況-年度 (預設今年度)
                this.modal.plant.valueA_YEAR = mNowDate.getFullYear() - 1911;
                //種植情況-期作
                this.modal.plant.valuePERIOD = "";
                //種植情況-土地狀態
                this.modal.plant.valueSTATE_P = "";
                //種植情況-種植面積
                this.modal.plant.valueAREA_P = "";
                //種植情況-種植日期
                this.modal.plant.valueDATE_P = "";
            },
            //定位
            onPosition:function(){
                if(this.modal.plant.valuePOSITION == ""){  alert(this.getPleaseEnterField("定位地址"));  return false; }
                this.getPositionInfo(this.modal.plant.valuePOSITION);
            },
            // 下載QrCode圖片
            onDownloadQrCode:function(){

                //藉型別陣列建構的 blob 來建立 URL 
                var link = document.createElement("a");
                document.body.appendChild(link);
                //因為部分瀏覽器，他的img src 可能是因為 base64 所以取不到資料，他會是如下情形(目前所知，Android  chrome手機板 會有這個問題，但切換到電腦版卻不會)
                //<img alt="Scan me!" style="display: block;">
                //link.href = document.querySelector("#qr_code_img img").src;
                //link.href = document.querySelector("#qr_code_img img").src.replace(/(\r\n)|(\n)|(\r)/g, '');
                //暫時先改成這樣
                const canvas = document.querySelector("#qr_code_img canvas");
                link.href = canvas.toDataURL();
                link.download = "qr_code.png";
                link.click();
               //this.downloadBase64(document.querySelector("#qr_code_img img").src);
            },
            downloadBase64:function (base64) {
                var arr = base64.split(',');
                var bytes = atob(arr[1]);
                let ab = new ArrayBuffer(bytes.length);
                let ia = new Uint8Array(ab);
                for (let i = 0; i < bytes.length; i++) {
                    ia[i] = bytes.charCodeAt(i);
                }
                var blob = new Blob([ab], { type: 'application/octet-stream' });
                var url = URL.createObjectURL(blob);
                var a = document.createElement('a');
                a.href = url;
                a.download = "qr_code.png";
                var e = document.createEvent('MouseEvents');
                e.initMouseEvent(
                    'click',
                    true,
                    false,
                    window,
                    0,
                    0,
                    0,
                    0,
                    0,
                    false,
                    false,
                    false,
                    false,
                    0,
                    null
                );
                a.dispatchEvent(e);
                URL.revokeObjectURL(url);
            },
            // 重新登記
            onAgainRegister:function(){

                var yes = confirm(this.message.qrCodeConfirmAgainRegister);
                if (yes) 
                {
                    //你按了確定按鈕
                    this.plant = [];
                    this.form.isSubmitDone = false;
                } 
                else 
                {
                    //你按了取消按鈕 
                }
            },
            //種植紀錄提交
            plantRegister:function(){

                this.enableDefaultLoad();
                this.apiPlantRegister({

                    UserName:window.vue.form.valueUserName,
                    UserPhone:window.vue.form.valueUserPhone,
                    Plant:window.vue.plant
                })
                .then((res)=>{

                    window.vue.setQrCode(res.data);
                    window.vue.form.isSubmitDone = true;
                    window.vue.disableDefaultLoad();
                })
                .catch((err)=> {
                    console.log(err);
                    window.vue.disableDefaultLoad();
                }); 

            },        
        },
    }

</script>
<style scoped>


[v-cloak] {

    display: none;

}

/** 下拉選單 */
select
{
    height: 30px;
}

/** 必填欄位 */
.required
{
    color: #FF0000;
}

/** 彈出視窗 */
/** 整行 */
.w3-modal .w3-row
{
    margin-top: 10px;
}

/** 表單及清單 */
#plant_register
{
    text-align: -webkit-center;
}

/** 表單 */
#plant_form
{
    max-width: 600px;
}
/** 表單-標頭 */
#plant_form .header-title
{
    font-size: 20px;
    margin-top: 20px !important;
}
/** 表單-欄位 */
#plant_form .field
{
    width:100px;
}

/** 清單 */
#plant_list
{
    max-width: 600px;
    padding-bottom: 10px;
}
/** 清單-項目 */
#plant_list .item
{
    margin: 10px;
}
/** 清單-標頭 */
#plant_list .header-title
{
    text-align:right;
    font-weight: 500;
}
/** 清單-農民登記資訊 */
#plant_list .info
{
    text-align:left; 
    border-bottom:1px #CCC solid; padding-bottom:1px;
}
/** 清單-農民登記資訊 欄位 */
#plant_list .info .field
{
    font-weight: 400;
    color:#000000; 
}
/** 清單-農民登記資訊 數值 */
#plant_list .info .value
{
    color:#000093;
    font-style:oblique;
}

/** 新增、送出按鈕群 */
.plant_btns_insert_send
{
    text-align:right;
    max-width: 600px;
    padding-right: 10px;
}

/** 目前共有 n 筆種植紀錄 */
.plant_amount
{
    color:#844200;
    max-width: 600px;
    font-weight: 500;
    padding-left: 10px;
    text-align:left;
}

/** 清單為空訊息 */
#plant_empty_message
{
    max-width: 600px;
}

/** 清單為空訊息 標頭 */
#plant_empty_message .header-title
{
    margin-top: 30px !important;
    font-size: 1.2rem;
    padding-left: 25px;
    padding-right: 25px;
    text-align:left;
}

/** 清單為空訊息 描述 */
#plant_empty_message .description
{
    font-size: 16px;
    padding-left: 25px;
    padding-right: 25px;
    font-size: 1rem;
    text-align: left;
}    

/** 圖台 */
#map
{
    height: 300px;
    max-width: 450px;
}


/** 領取獎勵 */
#receive_award
{
    text-align: -webkit-center;
}

/** QrCode */
#qr_code
{
    max-width: 450px; 
    text-align: -webkit-center;
}



/** 兌換表單 */
#award_form
{
    text-align: -webkit-center;
}

#award_form .page
{
    max-width: 450px; 
}

/** 公用表單畫面 */
.form-style
{
    min-height: 360px;
}
/** 公用表單畫面-標頭 */
.form-style .header-title
{
    margin-top: 30px !important;
    font-weight: bold;
    font-size: 1.75rem;
}
/** 公用表單畫面-圖片 */
.form-style .img-body
{
    width:30%;
    min-width: 150px !important;
}
/** 公用表單畫面-描述 */
.form-style .description
{
    margin-top: 20px !important;
    font-size: 1.2rem;
}

/** 新增、修改彈出視窗 內容 */
#dialog_register .body
{
    max-width: 560px;
}

/** 新增、修改彈出視窗 欄位 */
#dialog_register .field
{
    text-align:right;
    font-weight: 500;
    margin-bottom: 0px;
    margin-top: 8px;
    padding-right: 3px;
    width:35%;
}

/** 新增、修改彈出視窗 數值 */
#dialog_register .value
{
    width:65%;
    padding: 5px;
}

</style>